module.exports = __webpack_public_path__ + "static/media/itsme-auth.55cd5ce1.png";